import { ResponseError } from '@/lib/exceptions';

export const isUserNotSignedError = (error: { message: string | string[] } | unknown): boolean => {
  if (error instanceof ResponseError && error.message.includes('User not signed in')) {
    return true;
  }
  return false;
};
